// res import
import './images-import';
// script import
import VMModals from './vmodels/modals';
import {mountIfElExist} from './utils/miscellanea';
import Event from './utils/Event';
import {delay} from './utils/async';
import VMMain from './vmodels/main';
import {VMFlMenu, VMMenu} from './vmodels/menu';
import VMCases from './vmodels/cases';
import VMAbout from './vmodels/about';
import AOS from 'aos';
import 'aos/src/sass/aos.scss';
import VMService from './vmodels/service';
import VMFrch from './vmodels/frch';
import VMContacts from './vmodels/contacts';
import VMArticle from './vmodels/article';
import VMBlog from './vmodels/blog';
import VMFrch2 from './vmodels/frch2';
import VMPromo1 from './vmodels/promo1';
import VModal from 'vue-js-modal';
import Vue from 'vue';
import VMBranch from "./vmodels/branch";
import VMFrch3 from "./vmodels/frch3";
import VMVideo from "./vmodels/video";

const viewModels = [];

export async function startApp(): Promise<void> {

  Vue.use(VModal, {dynamic: true, dynamicDefaults: {clickToClose: true}});

  mountIfElExist(
    {vueExt: VMModals, elId: 'modals'},
    {vueExt: VMMain, elId: 'main'},
    {vueExt: VMMenu, elId: 'menu'},
    {vueExt: VMFlMenu, elId: 'fl-menu'},
    {vueExt: VMCases, elId: 'cases'},
    {vueExt: VMAbout, elId: 'about'},
    {vueExt: VMService, elId: 'service'},
    {vueExt: VMFrch, elId: 'frch'},
    {vueExt: VMFrch2, elId: 'frch2'},
    {vueExt: VMFrch3, elId: 'frch3'},
    {vueExt: VMContacts, elId: 'contacts'},
    {vueExt: VMArticle, elId: 'article'},
    {vueExt: VMBlog, elId: 'blog'},
    {vueExt: VMVideo, elId: 'video'},
    {vueExt: VMPromo1, elId: 'promo1'},
    {vueExt: VMBranch, elId: 'vm-branch'},
  );

  // @ts-ignore
  window.EventBus = Event;

  AOS.init({
    // disable: 'phone',
    once: true,
  });

  await delay(50);

  document.body.classList.add('site--visible');
}
